// Pieces of one textile line by set of markings (`combos()` of the mockup), the largest first and the unmarked
// pieces last. On one size the pieces of a partial marking count among those of a larger one: the 10 pieces
// marked on the shoulder are part of the 20 marked on the back. Same rule as Estimates::MarkingPlan.
//
// rows: [{ quantity, allocations: { [markingKey]: pieces } }], markingKeys: the plan's columns, in order
// Returns [{ markings: [markingKey…], pieces }]; an empty `markings` holds the unmarked pieces.
export function markingCombinations(rows, markingKeys) {
  const bySet = new Map()

  rows.forEach(({ quantity, allocations }) => {
    const allocated = key => allocations[key] || 0
    const cuts = [ ...new Set([ 0, quantity, ...markingKeys.map(key => Math.min(quantity, allocated(key))) ]) ]
      .sort((a, b) => a - b)

    for (let index = 0; index < cuts.length - 1; index++) {
      const markings = markingKeys.filter(key => allocated(key) >= cuts[index + 1])
      const id = markings.join("|")
      const entry = bySet.get(id) || { markings, pieces: 0 }
      entry.pieces += cuts[index + 1] - cuts[index]
      bySet.set(id, entry)
    }
  })

  return [ ...bySet.values() ].sort((a, b) => (a.markings.length === 0) - (b.markings.length === 0) || b.pieces - a.pieces)
}
